export class Csp5010Class {
    UserNam: string;
}
